import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _09dd56dc = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _18bb86f1 = () => interopDefault(import('../pages/ai_photo_enhancer_app/index.vue' /* webpackChunkName: "pages/ai_photo_enhancer_app/index" */))
const _0dbf28b2 = () => interopDefault(import('../pages/demo/index.vue' /* webpackChunkName: "pages/demo/index" */))
const _ce1d70d8 = () => interopDefault(import('../pages/download.vue' /* webpackChunkName: "pages/download" */))
const _0f1774c6 = () => interopDefault(import('../pages/downloadApp.vue' /* webpackChunkName: "pages/downloadApp" */))
const _410bfcb7 = () => interopDefault(import('../pages/explore.vue' /* webpackChunkName: "pages/explore" */))
const _02b5b20a = () => interopDefault(import('../pages/formula.vue' /* webpackChunkName: "pages/formula" */))
const _3ad72d66 = () => interopDefault(import('../pages/image-page.vue' /* webpackChunkName: "pages/image-page" */))
const _13b6dba3 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _0b210d51 = () => interopDefault(import('../pages/terms-of-service.vue' /* webpackChunkName: "pages/terms-of-service" */))
const _41b50eaf = () => interopDefault(import('../pages/vip_discount.vue' /* webpackChunkName: "pages/vip_discount" */))
const _dcfe74ce = () => interopDefault(import('../pages/agent/chat-replay/index.vue' /* webpackChunkName: "pages/agent/chat-replay/index" */))
const _2f747e8e = () => interopDefault(import('../pages/agent/quick-guide/index.vue' /* webpackChunkName: "pages/agent/quick-guide/index" */))
const _03ea30cb = () => interopDefault(import('../pages/campaign/photo-enhancer-mobile-sem.vue' /* webpackChunkName: "pages/campaign/photo-enhancer-mobile-sem" */))
const _64f3bd7e = () => interopDefault(import('../pages/demo/animate.vue' /* webpackChunkName: "pages/demo/animate" */))
const _4d6fbe26 = () => interopDefault(import('../pages/demo/dir.vue' /* webpackChunkName: "pages/demo/dir" */))
const _e9f8ff70 = () => interopDefault(import('../pages/demo/goart-general-article-layout.vue' /* webpackChunkName: "pages/demo/goart-general-article-layout" */))
const _a113ae32 = () => interopDefault(import('../pages/demo/goart-general-confirm-box.vue' /* webpackChunkName: "pages/demo/goart-general-confirm-box" */))
const _4e9a20fe = () => interopDefault(import('../pages/demo/info.vue' /* webpackChunkName: "pages/demo/info" */))
const _b6dd4d72 = () => interopDefault(import('../pages/demo/mediaDemo.vue' /* webpackChunkName: "pages/demo/mediaDemo" */))
const _07fb13b0 = () => interopDefault(import('../pages/demo/moreDemo.vue' /* webpackChunkName: "pages/demo/moreDemo" */))
const _3943e1e7 = () => interopDefault(import('../pages/demo/native.vue' /* webpackChunkName: "pages/demo/native" */))
const _0868e19d = () => interopDefault(import('../pages/demo/sdkDemo.vue' /* webpackChunkName: "pages/demo/sdkDemo" */))
const _087f83ad = () => interopDefault(import('../pages/demo/svg-pause.vue' /* webpackChunkName: "pages/demo/svg-pause" */))
const _f141a466 = () => interopDefault(import('../pages/demo/svg-play.vue' /* webpackChunkName: "pages/demo/svg-play" */))
const _1637db5c = () => interopDefault(import('../pages/demo/testMedia.vue' /* webpackChunkName: "pages/demo/testMedia" */))
const _787f9264 = () => interopDefault(import('../pages/demo/video-test-component.vue' /* webpackChunkName: "pages/demo/video-test-component" */))
const _a51018a2 = () => interopDefault(import('../pages/demo/videoPlay.vue' /* webpackChunkName: "pages/demo/videoPlay" */))
const _1957305c = () => interopDefault(import('../pages/desktop/Fotor_Qt_License_Notice.vue' /* webpackChunkName: "pages/desktop/Fotor_Qt_License_Notice" */))
const _55739c20 = () => interopDefault(import('../pages/desktop/FotorDesign_Qt_License_Notice.vue' /* webpackChunkName: "pages/desktop/FotorDesign_Qt_License_Notice" */))
const _5f6e007f = () => interopDefault(import('../pages/desktop/GoArt_Qt_License_Notice.vue' /* webpackChunkName: "pages/desktop/GoArt_Qt_License_Notice" */))
const _75e1fc76 = () => interopDefault(import('../pages/desktop/privacy-policy.vue' /* webpackChunkName: "pages/desktop/privacy-policy" */))
const _1a2badf1 = () => interopDefault(import('../pages/desktop/term-of-service.vue' /* webpackChunkName: "pages/desktop/term-of-service" */))
const _56e214a0 = () => interopDefault(import('../pages/facewow/privacy-policy.vue' /* webpackChunkName: "pages/facewow/privacy-policy" */))
const _5252917f = () => interopDefault(import('../pages/facewow/privacy-policy-desktop.vue' /* webpackChunkName: "pages/facewow/privacy-policy-desktop" */))
const _ddc44812 = () => interopDefault(import('../pages/facewow/term-of-service.vue' /* webpackChunkName: "pages/facewow/term-of-service" */))
const _3b9640c6 = () => interopDefault(import('../pages/facewow/term-of-service-desktop.vue' /* webpackChunkName: "pages/facewow/term-of-service-desktop" */))
const _29694da8 = () => interopDefault(import('../pages/goart/download.vue' /* webpackChunkName: "pages/goart/download" */))
const _318deb23 = () => interopDefault(import('../pages/goart/download_v2.vue' /* webpackChunkName: "pages/goart/download_v2" */))
const _706354ee = () => interopDefault(import('../pages/mobile/aboutsubscription.vue' /* webpackChunkName: "pages/mobile/aboutsubscription" */))
const _4c4f8c75 = () => interopDefault(import('../pages/mobile/agent-rule.vue' /* webpackChunkName: "pages/mobile/agent-rule" */))
const _32cac463 = () => interopDefault(import('../pages/mobile/ai-photo-enhancer.vue' /* webpackChunkName: "pages/mobile/ai-photo-enhancer" */))
const _7d61dc68 = () => interopDefault(import('../pages/mobile/aigc_faq.vue' /* webpackChunkName: "pages/mobile/aigc_faq" */))
const _2730922c = () => interopDefault(import('../pages/mobile/cancel-fotor-account.vue' /* webpackChunkName: "pages/mobile/cancel-fotor-account" */))
const _a2bd13ee = () => interopDefault(import('../pages/mobile/clipfly_rule.vue' /* webpackChunkName: "pages/mobile/clipfly_rule" */))
const _fe423f1e = () => interopDefault(import('../pages/mobile/jump_schema.vue' /* webpackChunkName: "pages/mobile/jump_schema" */))
const _30b17d62 = () => interopDefault(import('../pages/mobile/redeem_code.vue' /* webpackChunkName: "pages/mobile/redeem_code" */))
const _5cfd13c1 = () => interopDefault(import('../pages/mobile/resource_detail.vue' /* webpackChunkName: "pages/mobile/resource_detail" */))
const _e7bc67c8 = () => interopDefault(import('../pages/mobile/rule-description.vue' /* webpackChunkName: "pages/mobile/rule-description" */))
const _389cbe74 = () => interopDefault(import('../pages/mobile/tool_guide.vue' /* webpackChunkName: "pages/mobile/tool_guide" */))
const _4ebdd1ae = () => interopDefault(import('../pages/mobile/verif-user.vue' /* webpackChunkName: "pages/mobile/verif-user" */))
const _34a3fefe = () => interopDefault(import('../pages/mobile/welcome.vue' /* webpackChunkName: "pages/mobile/welcome" */))
const _18c38072 = () => interopDefault(import('../pages/mobile/welcome-user.vue' /* webpackChunkName: "pages/mobile/welcome-user" */))
const _e1c41bca = () => interopDefault(import('../pages/mobile/welcome-user备份2023-6-14.vue' /* webpackChunkName: "pages/mobile/welcome-user备份2023-6-14" */))
const _3e6f4dbe = () => interopDefault(import('../pages/mobile/welcome备份2023-6-14.vue' /* webpackChunkName: "pages/mobile/welcome备份2023-6-14" */))
const _7fdfe3b4 = () => interopDefault(import('../pages/portraitme/privacy-policy-desktop.vue' /* webpackChunkName: "pages/portraitme/privacy-policy-desktop" */))
const _f4ef4e02 = () => interopDefault(import('../pages/portraitme/term-of-service-desktop.vue' /* webpackChunkName: "pages/portraitme/term-of-service-desktop" */))
const _07cd5787 = () => interopDefault(import('../pages/mobile/activity/christmas-2021.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2021" */))
const _07db6f08 = () => interopDefault(import('../pages/mobile/activity/christmas-2022.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2022" */))
const _c9a17b68 = () => interopDefault(import('../pages/mobile/activity/christmas-2023/index.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2023/index" */))
const _3013f50d = () => interopDefault(import('../pages/mobile/activity/christmas-2024/index.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2024/index" */))
const _073e4991 = () => interopDefault(import('../pages/mobile/activity/free_code.vue' /* webpackChunkName: "pages/mobile/activity/free_code" */))
const _0ee9bf92 = () => interopDefault(import('../pages/mobile/activity/function.vue' /* webpackChunkName: "pages/mobile/activity/function" */))
const _59d6df76 = () => interopDefault(import('../pages/mobile/activity/function-bg-remove.vue' /* webpackChunkName: "pages/mobile/activity/function-bg-remove" */))
const _02df2a9d = () => interopDefault(import('../pages/mobile/activity/halloween-2022.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2022" */))
const _01898bbe = () => interopDefault(import('../pages/mobile/activity/halloween-2023/index.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2023/index" */))
const _d7c0263c = () => interopDefault(import('../pages/mobile/activity/halloween-2024/index.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2024/index" */))
const _638c8178 = () => interopDefault(import('../pages/mobile/activity/join_fotor_code.vue' /* webpackChunkName: "pages/mobile/activity/join_fotor_code" */))
const _6f26f232 = () => interopDefault(import('../pages/mobile/activity/join_terabox_code.vue' /* webpackChunkName: "pages/mobile/activity/join_terabox_code" */))
const _3c41d4fa = () => interopDefault(import('../pages/mobile/activity/price-increase-notification.vue' /* webpackChunkName: "pages/mobile/activity/price-increase-notification" */))
const _24c37b1e = () => interopDefault(import('../pages/mobile/activity/share_free_code.vue' /* webpackChunkName: "pages/mobile/activity/share_free_code" */))
const _a1c8fd5e = () => interopDefault(import('../pages/mobile/activity/share-2025/index.vue' /* webpackChunkName: "pages/mobile/activity/share-2025/index" */))
const _64bcbf15 = () => interopDefault(import('../pages/mobile/activity/valentine-2023.vue' /* webpackChunkName: "pages/mobile/activity/valentine-2023" */))
const _4ab2159e = () => interopDefault(import('../pages/mobile/activity/wallpaperdesign.vue' /* webpackChunkName: "pages/mobile/activity/wallpaperdesign" */))
const _4faf0ea8 = () => interopDefault(import('../pages/mobile/clipfly/downloadApp.vue' /* webpackChunkName: "pages/mobile/clipfly/downloadApp" */))
const _169a7956 = () => interopDefault(import('../pages/mobile/clipfly/helpCenter/index.vue' /* webpackChunkName: "pages/mobile/clipfly/helpCenter/index" */))
const _558ef226 = () => interopDefault(import('../pages/mobile/clipfly/invite.vue' /* webpackChunkName: "pages/mobile/clipfly/invite" */))
const _2be9f875 = () => interopDefault(import('../pages/mobile/clipfly/song/index.vue' /* webpackChunkName: "pages/mobile/clipfly/song/index" */))
const _7066a4fe = () => interopDefault(import('../pages/mobile/clipfly/storys/index.vue' /* webpackChunkName: "pages/mobile/clipfly/storys/index" */))
const _0d62cb3a = () => interopDefault(import('../pages/mobile/clipfly/survey/index.vue' /* webpackChunkName: "pages/mobile/clipfly/survey/index" */))
const _5c5b5bed = () => interopDefault(import('../pages/mobile/facewow/cancel-facewow-account.vue' /* webpackChunkName: "pages/mobile/facewow/cancel-facewow-account" */))
const _1f0f9b47 = () => interopDefault(import('../pages/mobile/goArt/ai-picture-faq.vue' /* webpackChunkName: "pages/mobile/goArt/ai-picture-faq" */))
const _70abdfd0 = () => interopDefault(import('../pages/mobile/goArt/ai-picture-from-picutre.vue' /* webpackChunkName: "pages/mobile/goArt/ai-picture-from-picutre" */))
const _18446474 = () => interopDefault(import('../pages/mobile/goArt/blockInfo.vue' /* webpackChunkName: "pages/mobile/goArt/blockInfo" */))
const _6ed8717f = () => interopDefault(import('../pages/mobile/goArt/cancel-account.vue' /* webpackChunkName: "pages/mobile/goArt/cancel-account" */))
const _46bc1ec2 = () => interopDefault(import('../pages/mobile/goArt/exchange-code.vue' /* webpackChunkName: "pages/mobile/goArt/exchange-code" */))
const _63de4c2e = () => interopDefault(import('../pages/mobile/goArt/invite.vue' /* webpackChunkName: "pages/mobile/goArt/invite" */))
const _d90bc222 = () => interopDefault(import('../pages/mobile/goArt/invite-2024.vue' /* webpackChunkName: "pages/mobile/goArt/invite-2024" */))
const _07ec66f7 = () => interopDefault(import('../pages/mobile/goArt/invite-blind-box/index.vue' /* webpackChunkName: "pages/mobile/goArt/invite-blind-box/index" */))
const _5aad4836 = () => interopDefault(import('../pages/mobile/goArt/privacy_en.vue' /* webpackChunkName: "pages/mobile/goArt/privacy_en" */))
const _13aad82c = () => interopDefault(import('../pages/mobile/goArt/privacy_zh.vue' /* webpackChunkName: "pages/mobile/goArt/privacy_zh" */))
const _b2670510 = () => interopDefault(import('../pages/mobile/goArt/sdk_zh.vue' /* webpackChunkName: "pages/mobile/goArt/sdk_zh" */))
const _6074f2d5 = () => interopDefault(import('../pages/mobile/goArt/services_en.vue' /* webpackChunkName: "pages/mobile/goArt/services_en" */))
const _348eca54 = () => interopDefault(import('../pages/mobile/goArt/services_en_v2.vue' /* webpackChunkName: "pages/mobile/goArt/services_en_v2" */))
const _34729b52 = () => interopDefault(import('../pages/mobile/goArt/services_en_v3.vue' /* webpackChunkName: "pages/mobile/goArt/services_en_v3" */))
const _f813aa4c = () => interopDefault(import('../pages/mobile/goArt/services_zh.vue' /* webpackChunkName: "pages/mobile/goArt/services_zh" */))
const _0dc999b3 = () => interopDefault(import('../pages/mobile/goArt/user/index.vue' /* webpackChunkName: "pages/mobile/goArt/user/index" */))
const _693d9579 = () => interopDefault(import('../pages/mobile/goArt/work/index.vue' /* webpackChunkName: "pages/mobile/goArt/work/index" */))
const _08e9ad0c = () => interopDefault(import('../pages/mobile/helper/android_vip_upgrade.vue' /* webpackChunkName: "pages/mobile/helper/android_vip_upgrade" */))
const _61d114e6 = () => interopDefault(import('../pages/mobile/helper/beauty-camera.vue' /* webpackChunkName: "pages/mobile/helper/beauty-camera" */))
const _84551b10 = () => interopDefault(import('../pages/mobile/helper/center/index.vue' /* webpackChunkName: "pages/mobile/helper/center/index" */))
const _47e34f66 = () => interopDefault(import('../pages/mobile/helper/center2.vue' /* webpackChunkName: "pages/mobile/helper/center2" */))
const _19351f8a = () => interopDefault(import('../pages/mobile/helper/upgrade-android-to-ios.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-android-to-ios" */))
const _57ee8868 = () => interopDefault(import('../pages/mobile/helper/upgrade-android-to-mac.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-android-to-mac" */))
const _3ee3e58e = () => interopDefault(import('../pages/mobile/helper/upgrade-ios-to-android.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-ios-to-android" */))
const _3187ffee = () => interopDefault(import('../pages/mobile/helper/upgrade-ios-to-mac.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-ios-to-mac" */))
const _a910d96c = () => interopDefault(import('../pages/mobile/helper/vip_upgrade.vue' /* webpackChunkName: "pages/mobile/helper/vip_upgrade" */))
const _64a15f77 = () => interopDefault(import('../pages/mobile/helper/what-new.vue' /* webpackChunkName: "pages/mobile/helper/what-new" */))
const _46ce97c3 = () => interopDefault(import('../pages/mobile/activity/aigc/ai-cartoonizer.vue' /* webpackChunkName: "pages/mobile/activity/aigc/ai-cartoonizer" */))
const _1d404096 = () => interopDefault(import('../pages/mobile/activity/aigc/ai-ideal-mate.vue' /* webpackChunkName: "pages/mobile/activity/aigc/ai-ideal-mate" */))
const _3e1f3530 = () => interopDefault(import('../pages/mobile/activity/aigc/ai-sing.vue' /* webpackChunkName: "pages/mobile/activity/aigc/ai-sing" */))
const _fb574422 = () => interopDefault(import('../pages/mobile/clipfly/activity/rule.vue' /* webpackChunkName: "pages/mobile/clipfly/activity/rule" */))
const _14ca4028 = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/index.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/index" */))
const _d26eea72 = () => interopDefault(import('../pages/mobile/goArt/activity/new-self/index.vue' /* webpackChunkName: "pages/mobile/goArt/activity/new-self/index" */))
const _75f19176 = () => interopDefault(import('../pages/mobile/goArt/activity/valentines_day.vue' /* webpackChunkName: "pages/mobile/goArt/activity/valentines_day" */))
const _6a161ba9 = () => interopDefault(import('../pages/mobile/goArt/digital-collection/user-list.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/user-list" */))
const _1b448d88 = () => interopDefault(import('../pages/mobile/goArt/invite-blind-box/Invited-friends.vue' /* webpackChunkName: "pages/mobile/goArt/invite-blind-box/Invited-friends" */))
const _651f828c = () => interopDefault(import('../pages/mobile/goArt/invite-blind-box/lucky-draw-record.vue' /* webpackChunkName: "pages/mobile/goArt/invite-blind-box/lucky-draw-record" */))
const _33657672 = () => interopDefault(import('../pages/mobile/goArt/nft/casting-instructions.vue' /* webpackChunkName: "pages/mobile/goArt/nft/casting-instructions" */))
const _2e85fd4e = () => interopDefault(import('../pages/mobile/goArt/nft/helpCenter.vue' /* webpackChunkName: "pages/mobile/goArt/nft/helpCenter" */))
const _5622a45a = () => interopDefault(import('../pages/mobile/goArt/nft/how-to-check-nft-on-opensea.vue' /* webpackChunkName: "pages/mobile/goArt/nft/how-to-check-nft-on-opensea" */))
const _b494fd78 = () => interopDefault(import('../pages/mobile/goArt/nft/how-to-view-nft-works-in-opensea.vue' /* webpackChunkName: "pages/mobile/goArt/nft/how-to-view-nft-works-in-opensea" */))
const _7a4ea8ee = () => interopDefault(import('../pages/mobile/goArt/nft/news/index.vue' /* webpackChunkName: "pages/mobile/goArt/nft/news/index" */))
const _5078b934 = () => interopDefault(import('../pages/mobile/goArt/nft/what-is-encrypted-wallet.vue' /* webpackChunkName: "pages/mobile/goArt/nft/what-is-encrypted-wallet" */))
const _52e23965 = () => interopDefault(import('../pages/mobile/activity/halloween-2024/views/centerPage.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2024/views/centerPage" */))
const _1d8a28f2 = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/contribute.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/contribute" */))
const _6a997a70 = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/info.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/info" */))
const _f339af2a = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/record.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/record" */))
const _4281a849 = () => interopDefault(import('../pages/mobile/goArt/activity/new-self/info.vue' /* webpackChunkName: "pages/mobile/goArt/activity/new-self/info" */))
const _4d6a55ca = () => interopDefault(import('../pages/mobile/goArt/digital-collection/product/all-series.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/product/all-series" */))
const _278a0da0 = () => interopDefault(import('../pages/mobile/goArt/nft/article/1.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/1" */))
const _276dde9e = () => interopDefault(import('../pages/mobile/goArt/nft/article/2.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/2" */))
const _2751af9c = () => interopDefault(import('../pages/mobile/goArt/nft/article/3.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/3" */))
const _2735809a = () => interopDefault(import('../pages/mobile/goArt/nft/article/4.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/4" */))
const _27195198 = () => interopDefault(import('../pages/mobile/goArt/nft/article/5.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/5" */))
const _26fd2296 = () => interopDefault(import('../pages/mobile/goArt/nft/article/6.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/6" */))
const _256e7032 = () => interopDefault(import('../pages/mobile/goArt/nft/protocol/guidelines.vue' /* webpackChunkName: "pages/mobile/goArt/nft/protocol/guidelines" */))
const _0b1c4459 = () => interopDefault(import('../pages/mobile/goArt/nft/protocol/guidelines_v2.vue' /* webpackChunkName: "pages/mobile/goArt/nft/protocol/guidelines_v2" */))
const _b522c304 = () => interopDefault(import('../pages/mobile/goArt/nft/protocol/permission.vue' /* webpackChunkName: "pages/mobile/goArt/nft/protocol/permission" */))
const _2b98c676 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5ed46076 = () => interopDefault(import('../pages/mobile/goArt/digital-collection/mine/_id.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/mine/_id" */))
const _c66c74ba = () => interopDefault(import('../pages/mobile/goArt/digital-collection/product/_id.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/product/_id" */))
const _04a3e254 = () => interopDefault(import('../pages/mobile/goArt/nft/news/_id.vue' /* webpackChunkName: "pages/mobile/goArt/nft/news/_id" */))
const _54be7308 = () => interopDefault(import('../pages/mobile/open-app/_position.vue' /* webpackChunkName: "pages/mobile/open-app/_position" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _09dd56dc,
    name: "404"
  }, {
    path: "/ai_photo_enhancer_app",
    component: _18bb86f1,
    name: "ai_photo_enhancer_app"
  }, {
    path: "/demo",
    component: _0dbf28b2,
    name: "demo"
  }, {
    path: "/download",
    component: _ce1d70d8,
    name: "download"
  }, {
    path: "/downloadApp",
    component: _0f1774c6,
    name: "downloadApp"
  }, {
    path: "/explore",
    component: _410bfcb7,
    name: "explore"
  }, {
    path: "/formula",
    component: _02b5b20a,
    name: "formula"
  }, {
    path: "/image-page",
    component: _3ad72d66,
    name: "image-page"
  }, {
    path: "/privacy-policy",
    component: _13b6dba3,
    name: "privacy-policy"
  }, {
    path: "/terms-of-service",
    component: _0b210d51,
    name: "terms-of-service"
  }, {
    path: "/vip_discount",
    component: _41b50eaf,
    name: "vip_discount"
  }, {
    path: "/agent/chat-replay",
    component: _dcfe74ce,
    name: "agent-chat-replay"
  }, {
    path: "/agent/quick-guide",
    component: _2f747e8e,
    name: "agent-quick-guide"
  }, {
    path: "/campaign/photo-enhancer-mobile-sem",
    component: _03ea30cb,
    name: "campaign-photo-enhancer-mobile-sem"
  }, {
    path: "/demo/animate",
    component: _64f3bd7e,
    name: "demo-animate"
  }, {
    path: "/demo/dir",
    component: _4d6fbe26,
    name: "demo-dir"
  }, {
    path: "/demo/goart-general-article-layout",
    component: _e9f8ff70,
    name: "demo-goart-general-article-layout"
  }, {
    path: "/demo/goart-general-confirm-box",
    component: _a113ae32,
    name: "demo-goart-general-confirm-box"
  }, {
    path: "/demo/info",
    component: _4e9a20fe,
    name: "demo-info"
  }, {
    path: "/demo/mediaDemo",
    component: _b6dd4d72,
    name: "demo-mediaDemo"
  }, {
    path: "/demo/moreDemo",
    component: _07fb13b0,
    name: "demo-moreDemo"
  }, {
    path: "/demo/native",
    component: _3943e1e7,
    name: "demo-native"
  }, {
    path: "/demo/sdkDemo",
    component: _0868e19d,
    name: "demo-sdkDemo"
  }, {
    path: "/demo/svg-pause",
    component: _087f83ad,
    name: "demo-svg-pause"
  }, {
    path: "/demo/svg-play",
    component: _f141a466,
    name: "demo-svg-play"
  }, {
    path: "/demo/testMedia",
    component: _1637db5c,
    name: "demo-testMedia"
  }, {
    path: "/demo/video-test-component",
    component: _787f9264,
    name: "demo-video-test-component"
  }, {
    path: "/demo/videoPlay",
    component: _a51018a2,
    name: "demo-videoPlay"
  }, {
    path: "/desktop/Fotor_Qt_License_Notice",
    component: _1957305c,
    name: "desktop-Fotor_Qt_License_Notice"
  }, {
    path: "/desktop/FotorDesign_Qt_License_Notice",
    component: _55739c20,
    name: "desktop-FotorDesign_Qt_License_Notice"
  }, {
    path: "/desktop/GoArt_Qt_License_Notice",
    component: _5f6e007f,
    name: "desktop-GoArt_Qt_License_Notice"
  }, {
    path: "/desktop/privacy-policy",
    component: _75e1fc76,
    name: "desktop-privacy-policy"
  }, {
    path: "/desktop/term-of-service",
    component: _1a2badf1,
    name: "desktop-term-of-service"
  }, {
    path: "/facewow/privacy-policy",
    component: _56e214a0,
    name: "facewow-privacy-policy"
  }, {
    path: "/facewow/privacy-policy-desktop",
    component: _5252917f,
    name: "facewow-privacy-policy-desktop"
  }, {
    path: "/facewow/term-of-service",
    component: _ddc44812,
    name: "facewow-term-of-service"
  }, {
    path: "/facewow/term-of-service-desktop",
    component: _3b9640c6,
    name: "facewow-term-of-service-desktop"
  }, {
    path: "/goart/download",
    component: _29694da8,
    name: "goart-download"
  }, {
    path: "/goart/download_v2",
    component: _318deb23,
    name: "goart-download_v2"
  }, {
    path: "/mobile/aboutsubscription",
    component: _706354ee,
    name: "mobile-aboutsubscription"
  }, {
    path: "/mobile/agent-rule",
    component: _4c4f8c75,
    name: "mobile-agent-rule"
  }, {
    path: "/mobile/ai-photo-enhancer",
    component: _32cac463,
    name: "mobile-ai-photo-enhancer"
  }, {
    path: "/mobile/aigc_faq",
    component: _7d61dc68,
    name: "mobile-aigc_faq"
  }, {
    path: "/mobile/cancel-fotor-account",
    component: _2730922c,
    name: "mobile-cancel-fotor-account"
  }, {
    path: "/mobile/clipfly_rule",
    component: _a2bd13ee,
    name: "mobile-clipfly_rule"
  }, {
    path: "/mobile/jump_schema",
    component: _fe423f1e,
    name: "mobile-jump_schema"
  }, {
    path: "/mobile/redeem_code",
    component: _30b17d62,
    name: "mobile-redeem_code"
  }, {
    path: "/mobile/resource_detail",
    component: _5cfd13c1,
    name: "mobile-resource_detail"
  }, {
    path: "/mobile/rule-description",
    component: _e7bc67c8,
    name: "mobile-rule-description"
  }, {
    path: "/mobile/tool_guide",
    component: _389cbe74,
    name: "mobile-tool_guide"
  }, {
    path: "/mobile/verif-user",
    component: _4ebdd1ae,
    name: "mobile-verif-user"
  }, {
    path: "/mobile/welcome",
    component: _34a3fefe,
    name: "mobile-welcome"
  }, {
    path: "/mobile/welcome-user",
    component: _18c38072,
    name: "mobile-welcome-user"
  }, {
    path: "/mobile/welcome-user%E5%A4%87%E4%BB%BD2023-6-14",
    component: _e1c41bca,
    name: "mobile-welcome-user备份2023-6-14"
  }, {
    path: "/mobile/welcome%E5%A4%87%E4%BB%BD2023-6-14",
    component: _3e6f4dbe,
    name: "mobile-welcome备份2023-6-14"
  }, {
    path: "/portraitme/privacy-policy-desktop",
    component: _7fdfe3b4,
    name: "portraitme-privacy-policy-desktop"
  }, {
    path: "/portraitme/term-of-service-desktop",
    component: _f4ef4e02,
    name: "portraitme-term-of-service-desktop"
  }, {
    path: "/mobile/activity/christmas-2021",
    component: _07cd5787,
    name: "mobile-activity-christmas-2021"
  }, {
    path: "/mobile/activity/christmas-2022",
    component: _07db6f08,
    name: "mobile-activity-christmas-2022"
  }, {
    path: "/mobile/activity/christmas-2023",
    component: _c9a17b68,
    name: "mobile-activity-christmas-2023"
  }, {
    path: "/mobile/activity/christmas-2024",
    component: _3013f50d,
    name: "mobile-activity-christmas-2024"
  }, {
    path: "/mobile/activity/free_code",
    component: _073e4991,
    name: "mobile-activity-free_code"
  }, {
    path: "/mobile/activity/function",
    component: _0ee9bf92,
    name: "mobile-activity-function"
  }, {
    path: "/mobile/activity/function-bg-remove",
    component: _59d6df76,
    name: "mobile-activity-function-bg-remove"
  }, {
    path: "/mobile/activity/halloween-2022",
    component: _02df2a9d,
    name: "mobile-activity-halloween-2022"
  }, {
    path: "/mobile/activity/halloween-2023",
    component: _01898bbe,
    name: "mobile-activity-halloween-2023"
  }, {
    path: "/mobile/activity/halloween-2024",
    component: _d7c0263c,
    name: "mobile-activity-halloween-2024"
  }, {
    path: "/mobile/activity/join_fotor_code",
    component: _638c8178,
    name: "mobile-activity-join_fotor_code"
  }, {
    path: "/mobile/activity/join_terabox_code",
    component: _6f26f232,
    name: "mobile-activity-join_terabox_code"
  }, {
    path: "/mobile/activity/price-increase-notification",
    component: _3c41d4fa,
    name: "mobile-activity-price-increase-notification"
  }, {
    path: "/mobile/activity/share_free_code",
    component: _24c37b1e,
    name: "mobile-activity-share_free_code"
  }, {
    path: "/mobile/activity/share-2025",
    component: _a1c8fd5e,
    name: "mobile-activity-share-2025"
  }, {
    path: "/mobile/activity/valentine-2023",
    component: _64bcbf15,
    name: "mobile-activity-valentine-2023"
  }, {
    path: "/mobile/activity/wallpaperdesign",
    component: _4ab2159e,
    name: "mobile-activity-wallpaperdesign"
  }, {
    path: "/mobile/clipfly/downloadApp",
    component: _4faf0ea8,
    name: "mobile-clipfly-downloadApp"
  }, {
    path: "/mobile/clipfly/helpCenter",
    component: _169a7956,
    name: "mobile-clipfly-helpCenter"
  }, {
    path: "/mobile/clipfly/invite",
    component: _558ef226,
    name: "mobile-clipfly-invite"
  }, {
    path: "/mobile/clipfly/song",
    component: _2be9f875,
    name: "mobile-clipfly-song"
  }, {
    path: "/mobile/clipfly/storys",
    component: _7066a4fe,
    name: "mobile-clipfly-storys"
  }, {
    path: "/mobile/clipfly/survey",
    component: _0d62cb3a,
    name: "mobile-clipfly-survey"
  }, {
    path: "/mobile/facewow/cancel-facewow-account",
    component: _5c5b5bed,
    name: "mobile-facewow-cancel-facewow-account"
  }, {
    path: "/mobile/goArt/ai-picture-faq",
    component: _1f0f9b47,
    name: "mobile-goArt-ai-picture-faq"
  }, {
    path: "/mobile/goArt/ai-picture-from-picutre",
    component: _70abdfd0,
    name: "mobile-goArt-ai-picture-from-picutre"
  }, {
    path: "/mobile/goArt/blockInfo",
    component: _18446474,
    name: "mobile-goArt-blockInfo"
  }, {
    path: "/mobile/goArt/cancel-account",
    component: _6ed8717f,
    name: "mobile-goArt-cancel-account"
  }, {
    path: "/mobile/goArt/exchange-code",
    component: _46bc1ec2,
    name: "mobile-goArt-exchange-code"
  }, {
    path: "/mobile/goArt/invite",
    component: _63de4c2e,
    name: "mobile-goArt-invite"
  }, {
    path: "/mobile/goArt/invite-2024",
    component: _d90bc222,
    name: "mobile-goArt-invite-2024"
  }, {
    path: "/mobile/goArt/invite-blind-box",
    component: _07ec66f7,
    name: "mobile-goArt-invite-blind-box"
  }, {
    path: "/mobile/goArt/privacy_en",
    component: _5aad4836,
    name: "mobile-goArt-privacy_en"
  }, {
    path: "/mobile/goArt/privacy_zh",
    component: _13aad82c,
    name: "mobile-goArt-privacy_zh"
  }, {
    path: "/mobile/goArt/sdk_zh",
    component: _b2670510,
    name: "mobile-goArt-sdk_zh"
  }, {
    path: "/mobile/goArt/services_en",
    component: _6074f2d5,
    name: "mobile-goArt-services_en"
  }, {
    path: "/mobile/goArt/services_en_v2",
    component: _348eca54,
    name: "mobile-goArt-services_en_v2"
  }, {
    path: "/mobile/goArt/services_en_v3",
    component: _34729b52,
    name: "mobile-goArt-services_en_v3"
  }, {
    path: "/mobile/goArt/services_zh",
    component: _f813aa4c,
    name: "mobile-goArt-services_zh"
  }, {
    path: "/mobile/goArt/user",
    component: _0dc999b3,
    name: "mobile-goArt-user"
  }, {
    path: "/mobile/goArt/work",
    component: _693d9579,
    name: "mobile-goArt-work"
  }, {
    path: "/mobile/helper/android_vip_upgrade",
    component: _08e9ad0c,
    name: "mobile-helper-android_vip_upgrade"
  }, {
    path: "/mobile/helper/beauty-camera",
    component: _61d114e6,
    name: "mobile-helper-beauty-camera"
  }, {
    path: "/mobile/helper/center",
    component: _84551b10,
    name: "mobile-helper-center"
  }, {
    path: "/mobile/helper/center2",
    component: _47e34f66,
    name: "mobile-helper-center2"
  }, {
    path: "/mobile/helper/upgrade-android-to-ios",
    component: _19351f8a,
    name: "mobile-helper-upgrade-android-to-ios"
  }, {
    path: "/mobile/helper/upgrade-android-to-mac",
    component: _57ee8868,
    name: "mobile-helper-upgrade-android-to-mac"
  }, {
    path: "/mobile/helper/upgrade-ios-to-android",
    component: _3ee3e58e,
    name: "mobile-helper-upgrade-ios-to-android"
  }, {
    path: "/mobile/helper/upgrade-ios-to-mac",
    component: _3187ffee,
    name: "mobile-helper-upgrade-ios-to-mac"
  }, {
    path: "/mobile/helper/vip_upgrade",
    component: _a910d96c,
    name: "mobile-helper-vip_upgrade"
  }, {
    path: "/mobile/helper/what-new",
    component: _64a15f77,
    name: "mobile-helper-what-new"
  }, {
    path: "/mobile/activity/aigc/ai-cartoonizer",
    component: _46ce97c3,
    name: "mobile-activity-aigc-ai-cartoonizer"
  }, {
    path: "/mobile/activity/aigc/ai-ideal-mate",
    component: _1d404096,
    name: "mobile-activity-aigc-ai-ideal-mate"
  }, {
    path: "/mobile/activity/aigc/ai-sing",
    component: _3e1f3530,
    name: "mobile-activity-aigc-ai-sing"
  }, {
    path: "/mobile/clipfly/activity/rule",
    component: _fb574422,
    name: "mobile-clipfly-activity-rule"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign",
    component: _14ca4028,
    name: "mobile-goArt-activity-ai-works-campaign"
  }, {
    path: "/mobile/goArt/activity/new-self",
    component: _d26eea72,
    name: "mobile-goArt-activity-new-self"
  }, {
    path: "/mobile/goArt/activity/valentines_day",
    component: _75f19176,
    name: "mobile-goArt-activity-valentines_day"
  }, {
    path: "/mobile/goArt/digital-collection/user-list",
    component: _6a161ba9,
    name: "mobile-goArt-digital-collection-user-list"
  }, {
    path: "/mobile/goArt/invite-blind-box/Invited-friends",
    component: _1b448d88,
    name: "mobile-goArt-invite-blind-box-Invited-friends"
  }, {
    path: "/mobile/goArt/invite-blind-box/lucky-draw-record",
    component: _651f828c,
    name: "mobile-goArt-invite-blind-box-lucky-draw-record"
  }, {
    path: "/mobile/goArt/nft/casting-instructions",
    component: _33657672,
    name: "mobile-goArt-nft-casting-instructions"
  }, {
    path: "/mobile/goArt/nft/helpCenter",
    component: _2e85fd4e,
    name: "mobile-goArt-nft-helpCenter"
  }, {
    path: "/mobile/goArt/nft/how-to-check-nft-on-opensea",
    component: _5622a45a,
    name: "mobile-goArt-nft-how-to-check-nft-on-opensea"
  }, {
    path: "/mobile/goArt/nft/how-to-view-nft-works-in-opensea",
    component: _b494fd78,
    name: "mobile-goArt-nft-how-to-view-nft-works-in-opensea"
  }, {
    path: "/mobile/goArt/nft/news",
    component: _7a4ea8ee,
    name: "mobile-goArt-nft-news"
  }, {
    path: "/mobile/goArt/nft/what-is-encrypted-wallet",
    component: _5078b934,
    name: "mobile-goArt-nft-what-is-encrypted-wallet"
  }, {
    path: "/mobile/activity/halloween-2024/views/centerPage",
    component: _52e23965,
    name: "mobile-activity-halloween-2024-views-centerPage"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign/contribute",
    component: _1d8a28f2,
    name: "mobile-goArt-activity-ai-works-campaign-contribute"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign/info",
    component: _6a997a70,
    name: "mobile-goArt-activity-ai-works-campaign-info"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign/record",
    component: _f339af2a,
    name: "mobile-goArt-activity-ai-works-campaign-record"
  }, {
    path: "/mobile/goArt/activity/new-self/info",
    component: _4281a849,
    name: "mobile-goArt-activity-new-self-info"
  }, {
    path: "/mobile/goArt/digital-collection/product/all-series",
    component: _4d6a55ca,
    name: "mobile-goArt-digital-collection-product-all-series"
  }, {
    path: "/mobile/goArt/nft/article/1",
    component: _278a0da0,
    name: "mobile-goArt-nft-article-1"
  }, {
    path: "/mobile/goArt/nft/article/2",
    component: _276dde9e,
    name: "mobile-goArt-nft-article-2"
  }, {
    path: "/mobile/goArt/nft/article/3",
    component: _2751af9c,
    name: "mobile-goArt-nft-article-3"
  }, {
    path: "/mobile/goArt/nft/article/4",
    component: _2735809a,
    name: "mobile-goArt-nft-article-4"
  }, {
    path: "/mobile/goArt/nft/article/5",
    component: _27195198,
    name: "mobile-goArt-nft-article-5"
  }, {
    path: "/mobile/goArt/nft/article/6",
    component: _26fd2296,
    name: "mobile-goArt-nft-article-6"
  }, {
    path: "/mobile/goArt/nft/protocol/guidelines",
    component: _256e7032,
    name: "mobile-goArt-nft-protocol-guidelines"
  }, {
    path: "/mobile/goArt/nft/protocol/guidelines_v2",
    component: _0b1c4459,
    name: "mobile-goArt-nft-protocol-guidelines_v2"
  }, {
    path: "/mobile/goArt/nft/protocol/permission",
    component: _b522c304,
    name: "mobile-goArt-nft-protocol-permission"
  }, {
    path: "/",
    component: _2b98c676,
    name: "index"
  }, {
    path: "/mobile/goArt/digital-collection/mine/:id?",
    component: _5ed46076,
    name: "mobile-goArt-digital-collection-mine-id"
  }, {
    path: "/mobile/goArt/digital-collection/product/:id?",
    component: _c66c74ba,
    name: "mobile-goArt-digital-collection-product-id"
  }, {
    path: "/mobile/goArt/nft/news/:id",
    component: _04a3e254,
    name: "mobile-goArt-nft-news-id"
  }, {
    path: "/mobile/open-app/:position?",
    component: _54be7308,
    name: "mobile-open-app-position"
  }, {
    path: "/mobile/clipfly/storys",
    component: _7066a4fe
  }, {
    path: "/mobile/clipfly/song",
    component: _2be9f875
  }, {
    path: "*",
    component: _09dd56dc,
    name: "custom-404"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
